import { render, staticRenderFns } from "./CardSingleArticle.vue?vue&type=template&id=504cc0ac&scoped=true"
import script from "./CardSingleArticle.vue?vue&type=script&lang=js"
export * from "./CardSingleArticle.vue?vue&type=script&lang=js"
import style0 from "./CardSingleArticle.vue?vue&type=style&index=0&id=504cc0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504cc0ac",
  null
  
)

export default component.exports